// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ks-3";
export var downloadButton = "_ks-4";
export var fileContainer = "_ks-9 _ks-7";
export var fileContainerBase = "_ks-7";
export var fileContainerBaseSm = "_ks-a _ks-7";
export var fileContainerFixedHeight = "_ks-8 _ks-7";
export var fileContainerFixedHeightSm = "_ks-c _ks-a _ks-7";
export var fileContainerSm = "_ks-b _ks-a _ks-7";
export var fileInfo = "_ks-5";
export var fileInfoWidthRestricted = "_ks-6";
export var fileType = "_ks-1";
export var fileTypeName = "_ks-2";
export var fileTypeSm = "_ks-d _ks-1";
export var image = "_ks-0";
export var link = "_ks-f";
export var overflowEllipsis = "_ks-e";